// result-verifier-sensitive-path-checks.ts
//
// Phase 06g R1d (debate Q4/B6): verifier step 5c. Runs right after 5b and
// BEFORE any recipe: the inventory diff was taken at step 4, so a hidden
// test-config edit (conftest.py, package.json#scripts, …) is refused before
// the controller would execute it through the recipe. Scope of the claim,
// stated plainly: this closes the *config* channel a reviewer does not read;
// test code the worker writes in an ordinary test file still runs under the
// worker and under the controller's recipe before a human sees the diff
// (C1 branch 2 stays open until the sandbox, C1c).
import { basename } from "node:path";
import { isSensitivePath } from "./sensitive-path-globs.js";

export interface AcceptanceRowLike {
  text: string;
}

/**
 * Returns the rejection reason for the FIRST changed sensitive path whose
 * basename no `acceptance[].text` mentions, `undefined` when all are covered.
 * Fail-closed: a ticket with no acceptance at all cannot touch these files.
 */
export function sensitivePathWithoutAcceptanceMention(
  changedPaths: readonly string[],
  acceptance: readonly AcceptanceRowLike[] | undefined,
): string | undefined {
  const texts = (acceptance ?? []).map((row) => row.text);
  for (const path of changedPaths) {
    if (!isSensitivePath(path)) continue;
    const name = basename(path);
    if (texts.some((text) => text.includes(name))) continue;
    return `sensitive_path_modified: ${path} — acceptance của ticket không nhắc "${name}" (file cấu hình test/CI/hook chỉ được sửa khi plan nêu tên file, để G2 thấy)`;
  }
  return undefined;
}
